import React, { useState } from 'react';
import { LayoutTemplateIcon, Loader2Icon, SparklesIcon, CopyIcon, ExternalLinkIcon } from 'lucide-react';
export function FlyerBuilder() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [format, setFormat] = useState('4:5');
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2000);
  };
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-323">
      <div data-id="element-324">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-325">
          Constructor de Flyers
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-326">
          Genera el copy exacto y guías de diseño para tus posts de Instagram y
          WhatsApp.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-327">
        <div className="space-y-4" data-id="element-328">
          <label className="block text-sm font-medium text-slate-700" data-id="element-329">
            Formato del Flyer
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-330">
            {[{
            id: '1:1',
            name: 'Post Cuadrado (1:1)',
            desc: 'Para Instagram Feed'
          }, {
            id: '4:5',
            name: 'Post Vertical (4:5)',
            desc: 'Mejor CTR en Feed'
          }, {
            id: '9:16',
            name: 'Story / Reel (9:16)',
            desc: 'Para Stories y TikTok'
          }].map(f => <button key={f.id} onClick={() => setFormat(f.id)} className={`flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all ${format === f.id ? 'border-indigo-600 bg-indigo-50 text-indigo-700' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-331">
                <div className={`border-2 border-current mb-3 ${f.id === '1:1' ? 'w-12 h-12' : f.id === '4:5' ? 'w-10 h-12' : 'w-8 h-14'} rounded-sm opacity-50`} data-id="element-332"></div>
                <span className="font-semibold" data-id="element-333">{f.name}</span>
                <span className="text-xs mt-1 opacity-70" data-id="element-334">{f.desc}</span>
              </button>)}
          </div>
        </div>

        <div className="mt-8 flex justify-end pt-6 border-t border-slate-100" data-id="element-335">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-336">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-337" /> Diseñando
                Copy...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-338" /> Generar Flyer Copy
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-in slide-in-from-bottom-4 duration-500" data-id="element-339">
          {/* Copy Section */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-340">
            <div className="bg-slate-50 border-b border-slate-200 p-4 flex items-center justify-between" data-id="element-341">
              <h3 className="font-semibold text-slate-800 flex items-center gap-2" data-id="element-342">
                <LayoutTemplateIcon className="w-5 h-5 text-indigo-600" data-id="element-343" /> Texto
                para el Flyer
              </h3>
              <button className="text-slate-500 hover:text-indigo-600 transition-colors" data-id="element-344">
                <CopyIcon className="w-5 h-5" data-id="element-345" />
              </button>
            </div>
            <div className="p-6 space-y-6" data-id="element-346">
              <div data-id="element-347">
                <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider" data-id="element-348">
                  Headline (Texto Principal Grande)
                </span>
                <h2 className="text-3xl font-black text-slate-900 mt-2 leading-tight" data-id="element-349">
                  DEJA DE REGALAR
                  <br data-id="element-350" />
                  TUS POSTRES
                </h2>
              </div>

              <div data-id="element-351">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-352">
                  Subhead (Texto Secundario)
                </span>
                <p className="text-lg font-medium text-slate-700 mt-1" data-id="element-353">
                  Aprende a costear y asegurar un 60% de ganancia.
                </p>
              </div>

              <div data-id="element-354">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-355">
                  Bullets (Beneficios)
                </span>
                <ul className="mt-2 space-y-2" data-id="element-356">
                  <li className="flex items-center gap-2 text-slate-700" data-id="element-357">
                    <span className="text-green-500" data-id="element-358">✓</span> Fórmula de costeo
                    en Excel
                  </li>
                  <li className="flex items-center gap-2 text-slate-700" data-id="element-359">
                    <span className="text-green-500" data-id="element-360">✓</span> Menú rentable de
                    10 postres
                  </li>
                  <li className="flex items-center gap-2 text-slate-700" data-id="element-361">
                    <span className="text-green-500" data-id="element-362">✓</span> Guía de empaques
                    económicos
                  </li>
                </ul>
              </div>

              <div className="bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-363">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-364">
                  Micro-Proof (Prueba Social)
                </span>
                <p className="text-sm font-medium text-slate-800 mt-1" data-id="element-365">
                  ⭐⭐⭐⭐⭐ +500 reposteras ya lo usan
                </p>
              </div>

              <div data-id="element-366">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-367">
                  CTA (Botón)
                </span>
                <div className="mt-2 inline-block bg-red-600 text-white font-bold px-6 py-2 rounded-full" data-id="element-368">
                  DESCARGAR GUÍA AHORA
                </div>
              </div>
            </div>
          </div>

          {/* Layout Guide Section */}
          <div className="bg-slate-900 rounded-xl shadow-lg border border-slate-800 overflow-hidden text-white" data-id="element-369">
            <div className="border-b border-slate-800 p-4" data-id="element-370">
              <h3 className="font-semibold text-white flex items-center gap-2" data-id="element-371">
                <SparklesIcon className="w-5 h-5 text-yellow-400" data-id="element-372" /> Guía de
                Diseño (Layout)
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-373">
              <div className="aspect-[4/5] bg-slate-800 rounded-lg relative border border-slate-700 flex flex-col items-center justify-center p-8 text-center" data-id="element-374">
                <div className="absolute top-4 left-4 right-4 bottom-4 border border-dashed border-slate-600/50 rounded pointer-events-none" data-id="element-375"></div>
                <span className="absolute top-2 left-1/2 -translate-x-1/2 text-[10px] text-slate-500 uppercase tracking-widest" data-id="element-376">
                  Zona Segura
                </span>

                <div className="w-full bg-slate-700/50 h-32 rounded mb-4 flex items-center justify-center border border-slate-600" data-id="element-377">
                  <span className="text-slate-400 text-sm font-medium" data-id="element-378">
                    Foto de postre premium (Fondo oscuro)
                  </span>
                </div>
                <h2 className="text-2xl font-black text-white mb-2 uppercase leading-none" data-id="element-379">
                  Deja de regalar
                  <br data-id="element-380" />
                  <span className="text-red-500" data-id="element-381">tus postres</span>
                </h2>
                <p className="text-sm text-slate-300 mb-4" data-id="element-382">
                  Aprende a costear y asegurar un 60% de ganancia.
                </p>
                <div className="bg-red-600 text-white text-xs font-bold px-4 py-2 rounded-full mt-auto" data-id="element-383">
                  DESCARGAR GUÍA
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-384">
                <div className="bg-slate-800 p-4 rounded-lg" data-id="element-385">
                  <span className="text-xs text-slate-400 uppercase tracking-wider block mb-2" data-id="element-386">
                    Colores Sugeridos
                  </span>
                  <div className="flex gap-2" data-id="element-387">
                    <div className="w-8 h-8 rounded-full bg-[#1F1F1F] border border-slate-600" title="Fondo Oscuro" data-id="element-388"></div>
                    <div className="w-8 h-8 rounded-full bg-[#DC2626] border border-slate-600" title="Acento Rojo" data-id="element-389"></div>
                    <div className="w-8 h-8 rounded-full bg-[#FFFBF0] border border-slate-600" title="Texto Claro" data-id="element-390"></div>
                  </div>
                </div>
                <div className="bg-slate-800 p-4 rounded-lg" data-id="element-391">
                  <span className="text-xs text-slate-400 uppercase tracking-wider block mb-2" data-id="element-392">
                    Tipografías
                  </span>
                  <p className="text-sm font-bold" data-id="element-393">Montserrat (Black)</p>
                  <p className="text-sm text-slate-300" data-id="element-394">Inter (Regular)</p>
                </div>
              </div>

              <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors" data-id="element-395">
                Abrir Plantilla en Canva{' '}
                <ExternalLinkIcon className="w-4 h-4" data-id="element-396" />
              </button>
            </div>
          </div>
        </div>}
    </div>;
}